import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateNumbers'
})
export class TruncateNumbersPipe implements PipeTransform {

  transform(value: number | string): string {
    console.log('TRUNCATE PIPE EJECUTÁNDOSE - Valor:', value, 'Tipo:', typeof value);

    if (value === null || value === undefined || value === '') {
      return '0';
    }

    // Si es string, remover puntos y convertir a número
    let numValue: number;
    if (typeof value === 'string') {
      // Remover puntos y convertir a número
      const cleanValue = value.replace(/\./g, '');
      numValue = parseFloat(cleanValue);
    } else {
      numValue = value;
    }

    if (isNaN(numValue)) {
      return '0';
    }

    // Formatear con puntos separadores de miles
    const formatted = numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    // Si supera 999.999.999, agregar "..." al final
    if (numValue >= 999999999) {
      console.log('TRUNCATE PIPE - Retornando con ...:', formatted + '...');
      return formatted + '...';
    }

    console.log('TRUNCATE PIPE - Retornando sin ...:', formatted);
    return formatted;
  }
}
